import { formatDateTime, formatRelativeTime } from "@/utils/formatters";

type Props = {
  last_checked_at?: string | null;
  next_check_at?: string | null;
};

export default function MonitoredPageCheckSchedule({ last_checked_at, next_check_at }: Props) {
  const hasSchedule = last_checked_at !== undefined || next_check_at !== undefined;
  if (!hasSchedule) {
    return null;
  }

  return (
    <span className="mt-2 block space-y-0.5 text-xs text-gray-500">
      <span className="block" title={last_checked_at ? formatDateTime(last_checked_at) : undefined}>
        Last checked: {last_checked_at ? formatRelativeTime(last_checked_at) : "not yet"}
      </span>
      <span className="block" title={next_check_at ? formatDateTime(next_check_at) : undefined}>
        Next check: {next_check_at ? formatRelativeTime(next_check_at) : "after the first check"}
      </span>
    </span>
  );
}
